
import { ApiSettings } from '../_generated/apiSettings';

export class Settings {
  public static createApiUrl(path: string): string {
    return Settings.createUrl(Settings.getUrl(Settings.ApiUrl) + 'api/', path);
  }

  public static createServerUrl(path: string): string {
    return Settings.createUrl(Settings.getUrl(Settings.ApiUrl), path);
  }

  public static createReportServiceUrl(path:string):string{
    return Settings.createUrl(Settings.getUrl(Settings.ReportServiceUrl), path);
  }

  public static getEnvironment(): string {
    if (!ApiSettings.Environment) 
      throw new Error('Environment is missing in generated apiSettings');
    return ApiSettings.Environment;
  }

  private static createUrl(root: string, path: string): string {
    if (path.indexOf('/') === 0) {
      path = path.substr(1);
    }

    return root + path;
  }

  private static getUrl(url: string): string {
    if (url.lastIndexOf('/') !== url.length - 1) {
      url = url + '/';
    }

    return url;
  }

  private static get ApiUrl() {
      return ApiSettings.ApiUrl;
  }

  private static get ReportServiceUrl(){
    return '';
  }
}
